import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  // 服务单-查询是否前置
  preServiceGet: (data) => apiAxios('post', baseURL + '/optionService.preServiceGetDetail', data),
  // 服务单-设置是否前置
  preServiceSet: (data) => apiAxios('post', baseURL + '/optionService.preServiceSetDetail', data),
  // 服务单-分类列表
  cateList: (data) => apiAxios('post', baseURL + '/optionService.cateList', data),
  // 服务单-操作内容列表
  optionContentList: (data) => apiAxios('post', baseURL + '/optionService.optionContentList', data),
  // 服务单-列表
  optionServiceList: (data) => apiAxios('post', baseURL + '/optionService.list', data),
  // 服务单-列表-统计
  listTabCount: (data) => apiAxios('post', baseURL + '/optionService.listTabCount', data),
  // 服务单-检品生成服务单
  inspectStoreService: (data) => apiAxios('post', baseURL + '/optionService.inspectStoreService', data),
  // 服务单-完成保存
  completeSave: (data) => apiAxios('post', baseURL + '/optionService.completeSave', data),
  // 服务单-开始处理
  optionServiceStart: (data) => apiAxios('post', baseURL + '/optionService.start', data),
  // 服务单-删除
  optionServiceDelete: (data) => apiAxios('post', baseURL + '/optionService.delete', data),
  // 服务单-明细删除
  deletePartial: (data) => apiAxios('post', baseURL + '/optionService.deletePartial', data),
  // 服务单-详情
  updateAdminId: (data, config) => apiAxios('post', baseURL + '/optionService.updateAdminId', data, config),
  // 服务单-保存
  optionServiceStore: (data) => apiAxios('post', baseURL + '/optionService.store', data),
  // 服务单-预览
  optionServicePreview: (data) => apiAxios('post', baseURL + '/optionService.preview', data),
  // 服务单-可选检品操作人员
  usableAdminList: (data) => apiAxios('post', baseURL + '/optionService.usableAdminList', data),
  // 已完成服务单：修改实际完成数量
  updateCompleteDetail: (data) => apiAxios('post', baseURL + '/optionService.updateCompleteDetail', data),
  // 待处理/处理中服务单：修改所选商品的需要操作数量
  updateShouldDetail: (data) => apiAxios('post', baseURL + '/optionService.updateShouldDetail', data),
  // 服务单明细-修改检品组长或机械操作员备注
  updateDetailRemark: (data) => apiAxios('post', baseURL + '/optionService.updateDetailRemark', data),
  // 服务单-拆分
  splitStore: (data) => apiAxios('post', baseURL + '/optionService.splitStore', data),
}
